import Flex from 'components/ui/Flex';
import Text from 'components/ui/Text';
import useAppSelector from 'hooks/useAppSelector';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

// The withdrawal pages render before any password or login wall, where only the anonymous init payload is
// available. They therefore use their own light layout in every access mode instead of the shop navigation,
// which needs a loaded shop.
const WithdrawalLayout = ({ children }: { children: React.ReactNode }) => {
    const { t } = useTranslation();
    const info = useAppSelector(({ shop }) => shop.info);

    return (
        <Background style={info?.backgroundImage ? { backgroundImage: `url("${info.backgroundImage}")` } : {}}>
            <Card>
                <Flex column align="center" className="mb-4">
                    {info?.logoType ? (
                        <Logo alt={info?.name ?? ''} src={info.logoType} />
                    ) : (
                        <Text fontSize={28} bold center>
                            {info?.name}
                        </Text>
                    )}
                </Flex>
                {children}
                <Flex justify="center" className="mt-4">
                    <a href="/">{t('withdrawal_back_to_shop')}</a>
                </Flex>
            </Card>
        </Background>
    );
};

const Background = styled.div`
    min-height: 100vh;
    padding: 24px 12px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: rgb(244, 244, 244);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
`;

const Card = styled.main`
    width: 100%;
    max-width: 760px;
    background-color: ${({ theme }) => theme.colors.fillWhite};
    padding: 2rem;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

    h1 {
        font-size: 1.75rem;
        line-height: 1.3;
        margin: 0 0 0.5rem 0;
    }
`;

const Logo = styled.img`
    max-height: 70px;
    max-width: 100%;
`;

export default WithdrawalLayout;
